export const SITE = {
  url: "https://przestrzenapps.pl",
  name: "Przestrzeń Apps",
  email: "przestrzenapps@gmail.com",
  phone: "+48531649531",
  phoneDisplay: "+48 531 649 531",
  socials: {
    linkedinMilosz: "https://www.linkedin.com/in/mi%C5%82osz-czarnecki-4a704b405/",
    linkedinDominika: "https://www.linkedin.com/in/dominika-majerczak-94447a398",
  },
  legal: {
    pl: "Przestrzeń Apps Dominika Majerczak · ul. Nowa 5A, 62-040 Puszczykowo · NIP 7831819315",
    en: "Przestrzeń Apps Dominika Majerczak · ul. Nowa 5A, 62-040 Puszczykowo · NIP 7831819315",
  },
};

export const META = {
  pl: {
    title: "Przestrzeń Apps — Strony www, aplikacje i SaaS · Poznań",
    description:
      "Tworzymy strony internetowe, aplikacje webowe i produkty SaaS dla firm z Polski i Europy. Partnerzy cyfrowi z Poznania — bez szablonów, z ludzkim podejściem. Praca zdalna.",
    ogTitle: "Przestrzeń Apps — Strony www, aplikacje i SaaS",
    ogDescription:
      "Strony firmowe, aplikacje webowe i SaaS z Poznania. Projektujemy i wdrażamy rozwiązania cyfrowe bez templatów — z ludzkim podejściem.",
  },
  en: {
    title: "Przestrzeń Apps — Websites, web apps & SaaS · Poznań",
    description:
      "We build websites, web applications and SaaS products for businesses across Poland and Europe. Digital partners from Poznań — no templates, human approach. Remote-first.",
    ogTitle: "Przestrzeń Apps — Websites, web apps & SaaS",
    ogDescription:
      "Company websites, web applications and SaaS from Poznań. We design and ship digital products without templates — with a human touch.",
  },
};

export function setMetaTag(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}